import { queryClient } from '../../application';
import { QueryClientProvider } from '@tanstack/react-query';
import { create } from 'zustand';

import InitialiseButton from './_components/InitialiseButton';
import InitialiseCategoriesCard from './_components/InitialiseCategoriesCard';
import InitialisePagesCard from './_components/InitialisePagesCard';
import InitialiseTemplatesCard from './_components/InitialiseTemplatesCard';
import InitialiseJobsCard from './_components/InitialiseJobsCard';

const useOnboardingStore = create((set) => ({
  isLoading: false,
  setIsLoading: (isLoading) => set(() => ({ isLoading })),

  categories: [],
  setCategories: (categories) => set(() => ({ categories })),
  pages: [],
  setPages: (pages) => set(() => ({ pages })),
  templates: [],
  setTemplates: (templates) => set(() => ({ templates })),

  isGenerateJobs: false,
  setIsGenerateJobs: (isGenerateJobs) => set(() => ({ isGenerateJobs })),
}));

export default function OnboardingWizard(props) {
  const { endpoints, existing_categories, existing_dynamic_pages, existing_dynamic_page_templates, options } = props;

  return (
    <QueryClientProvider client={queryClient}>
      <div className="d-flex flex-column gap-5">
        <div className="onboarding-container">
          <InitialiseCategoriesCard {...{ options: options.categories, useOnboardingStore, existing_categories }} />
          <InitialisePagesCard {...{ options: options.pages, useOnboardingStore, existing_dynamic_pages }} />
          <InitialiseTemplatesCard {...{ options: options.templates, useOnboardingStore, existing_dynamic_page_templates }} />
          <InitialiseJobsCard {...{ useOnboardingStore }} />
        </div>
        <div className="d-flex justify-content-center align-items-center">
          <InitialiseButton {...{ endpoints, useOnboardingStore }} />
        </div>
      </div>
    </QueryClientProvider>
  );
}
